import React, { useState } from "react";
import CertBuilderIssuance from "./CertBuilderIssuance";
import CertBuilderList from "./CertBuilderList";
import CertBuilderTemplateDesigner from "./CertBuilderTemplateDesigner";
import AdminCertParentRequests from "./AdminCertParentRequests";


const SwitchCertBuilder = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1: 
      return <AdminCertParentRequests />;
      case 2:
        return <CertBuilderIssuance />;
      case 3:
        return <CertBuilderList />;
      case 4:
        return <CertBuilderTemplateDesigner />;
      default:
        return <CertBuilderIssuance />;
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-4 bg-white rounded-lg">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${step === 1 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Certificate Requests</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${step === 2 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Generate Certificates</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${step === 3 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Certificate Registry</div>
          </div>
          <div
            onClick={() => setStep(4)}
            className={`iskool-tab-item ${step === 4 ? "bg-gray-600 text-white shadow" : ""}`}
          >
            <div className="text-lg">Template Designer</div>
          </div>
        </div>
        <div>{switchTab()}</div>
      </div>
    </>
  );
};

export default SwitchCertBuilder;

